"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EspoolLinearExtensionPosition = void 0;
/** auszug */
var EspoolLinearExtensionPosition;
(function (EspoolLinearExtensionPosition) {
    EspoolLinearExtensionPosition["center"] = "center";
    /** auszug right, tb position left */
    EspoolLinearExtensionPosition["right"] = "right";
    /** auszug left, tb position right */
    EspoolLinearExtensionPosition["left"] = "left";
})(EspoolLinearExtensionPosition = exports.EspoolLinearExtensionPosition || (exports.EspoolLinearExtensionPosition = {}));
//# sourceMappingURL=EspoolLinearExtension.js.map